<ng-container *ngIf="isHotelByPackage; else hotelFilterBar">
  <ng-container *ngTemplateOutlet="packageFilterBar"></ng-container>
</ng-container>

<ng-template #hotelFilterBar>
  <app-hotel-filter-bar-by-hotel
    [viewType]="viewType"
    [isSticky]="isSticky"
    [hourType]="hourType"
    (filtersHaveBeenApplicatedEvent)="filtersHaveBeenApplicatedAction($event)">
    <ng-container allFiltersTag="allFiltersTag" *ngTemplateOutlet="allFilters"></ng-container>
    <ng-container moreFiltersTag="moreFiltersTag" *ngTemplateOutlet="moreFilters"></ng-container>
  </app-hotel-filter-bar-by-hotel>
</ng-template>

<ng-template #packageFilterBar>
  <app-package-filter-bar
    [viewType]="viewType"
    [isSticky]="isSticky"
    (filtersHaveBeenApplicatedEvent)="filtersHaveBeenApplicatedAction($event)">
    <ng-container allFiltersTag="allFiltersTag" *ngTemplateOutlet="allFilters"></ng-container>
    <ng-container moreFiltersTag="moreFiltersTag" *ngTemplateOutlet="moreFilters"></ng-container>
  </app-package-filter-bar>
</ng-template>

<ng-template #moreFilters>
  <app-filter-bar-tag
    [class]="'more-filters'"
    [label]="'MORE_FILTERS'"
    [icon]="icons.Add"
    [toTranslate]="true"
    (clickEvent)="viewFilters.emit()">
  </app-filter-bar-tag>
</ng-template>

<ng-template #allFilters>
  <app-filter-bar-tag
    [class]="'all-filters'"
    [class.active]="filtersHaveBeenApplicated"
    [isActive]="filtersHaveBeenApplicated"
    [icon]="icons.Filter"
    (clickEvent)="viewFilters.emit()">
  </app-filter-bar-tag>
</ng-template>